export default "__VITE_ASSET__DCbyezeq__"